import { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import TransactionHistory from "./request_history/TransactionHistory"
import BetHistory230 from "./request_history/BetHistory230"
import Deposit from "../transactions/Deposit"
import Withdraw from "../transactions/Withdraw"

export default function Wallet({ onClose }) {
  const {
    filterTransactions,
    sg8Wallet,
    handleReturnWallet,
    username,
    loading,
  } = useGlobalContext()
  const [activeSection, setActiveSection] = useState("transaction-history")
  const [activePopup, setActivePopup] = useState(null)

  // Date filter states for "From Date" and "To Date"

  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")

  const tabList = [
    { id: 1, tab: "Transaction History", onClick: "transaction-history" },
    { id: 2, tab: "2/30 Bet History", onClick: "2-30-bet-history" },
    // { id: 3, tab: "Share Credits", onClick: "share-credits" },
  ]

  const handleOpenPopup = (type) => {
    setActivePopup(type)
  }

  const handleClosePopup = () => {
    setActivePopup(null)
  }

  useEffect(() => {
    document.body.style.overflow = activePopup ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [activePopup])

  const handleFilter = async () => {
    await filterTransactions(fromDate, toDate)
  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div className="openProfileItems-container">
      {windowWidth <= 840 && (
        <div className="close-profile-module-container">
          <div className="profile-logo">
            <a href="/">
              <img src="/images/icon/fgh-logo.webp" alt="FGH Logo" />
            </a>
          </div>
          <button className="close-profile-module-btn" onClick={onClose}>
            <img src="/images/icon/ARROW.webp" alt="" /> Back
          </button>
        </div>
      )}
      <div className="openWallet">
        <div className="wallet-section-1">
          <div>
            <div className="walletLabel">Available Balance</div>
            <div className="walletBalance">
              {loading ? "Preparing..." : sg8Wallet}
            </div>{" "}
            <div className="profile-wallet-return">
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#fff",
                }}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault()
                    handleReturnWallet(username)
                  }}
                  style={{
                    color: "#fff",
                    display: "flex",
                  }}
                >
                  <img
                    style={{
                      width: "12px",
                      height: "12px",
                      marginRight: "3px",
                    }}
                    src="/images/icon/FGH-RETURN-ICON.webp"
                    alt=""
                  />
                  Return Wallet
                </a>
              </p>
            </div>
          </div>
          {/* <div>
            <div className="walletLabel">
              Quick Deposit <span>[GCASH]</span>
            </div>
            <div className="walletQuickDeposit">
              <input
                type="number"
                className="inputQuickDeposit"
                placeholder="Enter Amount"
              />
              <button className="quickDeposit-btn">Submit</button>
            </div>
          </div> */}
        </div>
        <div className="wallet-section-2">
          <button
            className="deposit-btn"
            onClick={() => handleOpenPopup("deposit")}
          >
            Cash In
          </button>
          <button
            className="withdraw-btn"
            onClick={() => handleOpenPopup("withdraw")}
          >
            Cash out
          </button>
        </div>
        <div className="wallet-section-3">
          <ul className="profile-tablist">
            {tabList.map((data) => (
              <li
                key={data.id}
                onClick={() => setActiveSection(data.onClick)}
                className={activeSection === data.onClick ? "active" : ""}
              >
                {data.tab}
              </li>
            ))}
          </ul>
          {activeSection === "transaction-history" && <TransactionHistory />}
          {activeSection === "2-30-bet-history" && <BetHistory230 />}
          {/* {activeSection === "share-credits" && <div>asdasdsa</div>} */}
        </div>
        {activePopup === "deposit" && (
          <div>
            <Deposit onClose={handleClosePopup} />
          </div>
        )}
        {activePopup === "withdraw" && (
          <div>
            <Withdraw onClose={handleClosePopup} />
          </div>
        )}
      </div>
    </div>
  )
}
